import {css} from "styled-components";

export const subCategory = css`
    width: 65%!important;
    @media only screen and (max-width: 1024px) and (min-width: 641px) {
        width: 70%!important;
    }

    @media only screen and (max-width: 601px) {
        width: 80%!important;
    }
`;

export const entities = css`
    width: 70%!important;
    @media only screen and (max-width: 1024px) and (min-width: 641px) {
        width: 75%!important;
    }
`;
